"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStateController = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AppStateContext_1 = __importDefault(require("../useAppState/AppStateContext"));
const AppStateActionsContext_1 = __importDefault(require("../useAppStateActions/AppStateActionsContext"));
function AppStateController(props) {
    const { children } = props, appState = __rest(props, ["children"]);
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const manageReportsOpen = (0, react_1.useRef)(false);
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const currentLink = pathname.split('/')[1];
    const allNavs = (0, react_1.useMemo)(() => {
        var _a;
        let v = [];
        (_a = appState.navs) === null || _a === void 0 ? void 0 : _a.forEach(n => (v = [...v, n, ...(n.children || [])]));
        return v;
    }, [appState.navs]);
    (0, react_1.useEffect)(() => {
        setCtxChanged(new Date());
    }, [currentLink, allNavs]);
    const setManageReportsOpen = (0, react_1.useCallback)((open) => {
        manageReportsOpen.current = open;
        setCtxChanged(new Date());
    }, []);
    const actionsCtx = (0, react_1.useMemo)(() => ({ setManageReportsOpen }), [setManageReportsOpen]);
    const ctx = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, appState), { manageReportsOpen: manageReportsOpen.current })), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    return (react_1.default.createElement(AppStateActionsContext_1.default.Provider, { value: actionsCtx },
        react_1.default.createElement(AppStateContext_1.default.Provider, { value: ctx }, children)));
}
exports.AppStateController = AppStateController;
exports.default = AppStateController;
